export default __webpack_public_path__ + "static/opinion-2-dabc682e3a7377f6a099ccb3df8378fb.jpg";